// import MedsusFicha from '../../../daf/ProdutosDAF/MedSUS/Ficha';

export default function MedsusFichaSes() {
  return <>Ajustar</>;
}
